// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { getRuntimeEnvValue } from "../utils/runtimeEnv";

export const DARK_MODE_ENABLED_STORAGE_KEY = "riddle-dark-mode-enabled";

const CLIENT_FLAG = "VITE_UI_DARK_MODE_ENABLED";

function readFlag(value: string | undefined): boolean {
  if (typeof value !== "string") {
    return false;
  }
  const normalized = value.trim().toLowerCase();
  return normalized === "true" || normalized === "1";
}

export function isDarkModeEnabled(): boolean {
  return readFlag(getRuntimeEnvValue(CLIENT_FLAG));
}

export function syncDarkModeEnabledMarker(enabled: boolean): void {
  if (enabled) {
    localStorage.setItem(DARK_MODE_ENABLED_STORAGE_KEY, "1");
    return;
  }
  localStorage.removeItem(DARK_MODE_ENABLED_STORAGE_KEY);
}
